var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bottom"},[_c('el-pagination',{attrs:{"current-page":_vm.currentPage,"layout":"total, prev, pager, next, jumper","total":_vm.total,"page-size":_vm.pageSize},on:{"current-change":_vm.handleCurrentChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }